/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentInboundPhoneNumberDto } from '../models/AgentInboundPhoneNumberDto';
import type { CredentialDto } from '../models/CredentialDto';
import type { OutboundPhoneNumberRequestDto } from '../models/OutboundPhoneNumberRequestDto';
import type { OutboundPhoneNumberResponseDto } from '../models/OutboundPhoneNumberResponseDto';
import type { PhoneNumberDto } from '../models/PhoneNumberDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TelecomApiService {
    /**
     * Set inbound phone numbers
     * Saves or creates a phone number for inbound SIP integration
     * @param xAiAgentOrganizationContext
     * @param agentId
     * @param requestBody
     * @returns PhoneNumberDto Updated a phone number of SIP integration for inbound calls
     * @throws ApiError
     */
    public static putInboundPhoneNumber(
        xAiAgentOrganizationContext: string,
        agentId: string,
        requestBody: PhoneNumberDto,
    ): CancelablePromise<PhoneNumberDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telecom/sip/{agentId}/inbound/phone-number',
            path: {
                'agentId': agentId,
            },
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Set outbound phone numbers
     * Saves or creates a phone number of outbound SIP integration
     * @param xAiAgentOrganizationContext
     * @param requestBody
     * @returns OutboundPhoneNumberResponseDto Updated a phone number of SIP integration for outbound calls
     * @throws ApiError
     */
    public static putOutboundPhoneNumber(
        xAiAgentOrganizationContext: string,
        requestBody: OutboundPhoneNumberRequestDto,
    ): CancelablePromise<OutboundPhoneNumberResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telecom/sip/outbound/phone-number',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get credential for outbound calls
     * Fetch current credentials of outbound SIP integration
     * @param xAiAgentOrganizationContext
     * @returns CredentialDto Current credentials of SIP integration for outbound calls
     * @throws ApiError
     */
    public static getCredential(
        xAiAgentOrganizationContext: string,
    ): CancelablePromise<CredentialDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/sip/outbound/credential',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Set credential for outbound calls
     * Saves or creates credentials of outbound SIP integration
     * @param xAiAgentOrganizationContext
     * @param requestBody
     * @returns CredentialDto Updated credentials of SIP integration for outbound calls
     * @throws ApiError
     */
    public static putCredential(
        xAiAgentOrganizationContext: string,
        requestBody: CredentialDto,
    ): CancelablePromise<CredentialDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telecom/sip/outbound/credential',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a list of registered inbound phone numbers
     * Fetch list of registered phone numbers for inbound SIP integration
     * @param xAiAgentOrganizationContext
     * @param agentId
     * @returns PhoneNumberDto List of registered phone numbers for inbound calls
     * @throws ApiError
     */
    public static getInboundPhoneNumbers(
        xAiAgentOrganizationContext: string,
        agentId: string,
    ): CancelablePromise<Array<PhoneNumberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/sip/{agentId}/inbound/phone-numbers',
            path: {
                'agentId': agentId,
            },
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
        });
    }
    /**
     * Get a list of registered outbound phone numbers
     * Fetch a list of registered phone numbers for outbound SIP integration
     * @param xAiAgentOrganizationContext
     * @returns OutboundPhoneNumberResponseDto List of registered phone numbers for outbound calls
     * @throws ApiError
     */
    public static getOutboundPhoneNumbers(
        xAiAgentOrganizationContext: string,
    ): CancelablePromise<Array<OutboundPhoneNumberResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/sip/outbound/phone-numbers',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
        });
    }
    /**
     * Get a list of registered inbound phone numbers in the organization
     * Fetch list of registered phone numbers for inbound SIP integration per organization
     * @param xAiAgentOrganizationContext
     * @returns AgentInboundPhoneNumberDto List of registered phone numbers for inbound calls per organization
     * @throws ApiError
     */
    public static getAgentInboundPhoneNumbers(
        xAiAgentOrganizationContext: string,
    ): CancelablePromise<Array<AgentInboundPhoneNumberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/sip/inbound/phone-numbers',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
        });
    }
    /**
     * Get a list of available SIP providers
     * Fetch list of available SIP providers
     * @param xAiAgentOrganizationContext
     * @returns string List of available SIP providers
     * @throws ApiError
     */
    public static getSipProviders(
        xAiAgentOrganizationContext: string,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telecom/sip/providers',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletion of a registered inbound phone number
     * Delete a registered phone number of inbound SIP integration by id
     * @param xAiAgentOrganizationContext
     * @param agentId
     * @param phoneNumberId
     * @returns any Delete a registered phone numbers for inbound calls by id
     * @throws ApiError
     */
    public static deleteInboundPhoneNumber(
        xAiAgentOrganizationContext: string,
        agentId: string,
        phoneNumberId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/telecom/sip/{agentId}/inbound/phone-numbers/{phoneNumberId}',
            path: {
                'agentId': agentId,
                'phoneNumberId': phoneNumberId,
            },
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletion of a registered outbound phone number
     * Delete a registered phone number of outbound SIP integration by id
     * @param xAiAgentOrganizationContext
     * @param phoneNumberId
     * @returns any Delete a registered phone numbers for outbound calls by id
     * @throws ApiError
     */
    public static deleteOutboundPhoneNumber(
        xAiAgentOrganizationContext: string,
        phoneNumberId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/telecom/sip/outbound/phone-numbers/{phoneNumberId}',
            path: {
                'phoneNumberId': phoneNumberId,
            },
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
